import React, { } from 'react';
import * as Yup from 'yup';
// components
import Modal from 'shared/modals/Modal';
import { useSelector } from 'react-redux';
import { FormTextArea, PageForm } from '../../../../shared/components/forms';
import { Field, FormElement } from '@progress/kendo-react-form';
import { getRailbillingMethods } from 'src/slices/railbillingMethods';
import MarketsDropdown from '../../../../shared/components/dropdowns/MarketsDropdown';
import LocationsDropdown from '../../../../shared/components/dropdowns/LocationsDropdown';
import RailbillingMethodDropdown from 'src/shared/components/dropdowns/RailbillingMethodDropdown';
import { SaveButton } from '../../../../shared/components/buttons';
import { FormCheckbox, FormInput } from 'shared/formControls';
import isNil from 'lodash/isNil';

const CONTAINERYARD_LOCATION_TYPE = 1;
const PORT_LOCATION_TYPE = 5;
const RAIL_LOCATION_TYPE = 6;

const locationSchema = Yup.object().shape({
  terminalId: Yup.mixed().nullable().required('Terminal is Required'),
  locationId: Yup.mixed().nullable().required('Location is Required'),
  method: Yup.mixed().required('Method is required'),
  methodDetails: Yup.string().when(['method'], {
    is: (method) => (typeof method === 'object' ? method?.value == 0 : method == 0),
    then: Yup.string().email('Email is not valid'),
    otherwise: Yup.string().url('Url is iot valid'),
  }),
});

const OrganizationRailAndPortLocationsModal = ({
  organizationId,
  initialValues,
  onClose,
  resetForm,
  setSubmitting,
  isOpen,
}) => {
  const isEditing = initialValues && initialValues.id;
  const methods = useSelector(getRailbillingMethods);

  const handleReset = () => {
    onClose();
  };

  const handleDelete = () => {
    setSubmitting(true);
    onClose({ organizationId, ...initialValues, deleted: true });
    resetForm();
  };

  const handleSubmit = (data) => {
    const formattedData = {
      ...data,
      locationId: typeof data.locationId === 'object' ? data.locationId.id : data.locationId,
      terminalId: typeof data.terminalId === 'object' ? data.terminalId.id : data.terminalId,
      method: typeof data.method === 'object' ? data.method.value : data.method,
      emptyPickups: data.emptyPickups?.map((x) => (typeof x === 'object' ? x.id : x)),
      organizationId,
    };

    onClose(formattedData);
  };

  const getMethodDetailsLabel = (method) => {
    if (typeof method === 'object') {
      return method?.description;
    }

    return methods.find(({ value }) => value === method)?.description;
  };

  return (
    <Modal isOpen={isOpen} handleClose={handleReset} containerStyle='large'>
      <div className='modal-header'>
        <h5 className='modal-title' id='addAdditionalChargeModal'>
          {isEditing ? 'Edit' : 'Create'}
          {' '}
          Location
        </h5>
        <button type='button' className='button large close' onClick={handleReset} />
      </div>
      <PageForm
        id='rail-and-port-locations'
        name='rail-and-port-locations'
        initialValues={initialValues}
        validationSchema={locationSchema}
        hideActionBar
        onSubmit={handleSubmit}
        renderFields={({ onSubmit, valueGetter, onChange }) => {
          const handleMethodChange = (event) => {
            onChange('methodDetails', { value: '' });
          };
          return (
            <FormElement>
              <Field
                id='terminalId'
                name='terminalId'
                label='Market'
                component={MarketsDropdown}
              />
              <Field
                id='locationId'
                name='locationId'
                label='Location'
                component={LocationsDropdown}

              />
              <Field
                id='comment'
                name='comment'
                label='Comment'
                component={FormTextArea}
              />
              <Field id='importRailbillingRequired' name='importRailbillingRequired' label='Import Railbilling Required' component={FormCheckbox} />
              <Field id='exportRailbillingRequired' name='exportRailbillingRequired' label='Export Railbilling Required' component={FormCheckbox} />
              <Field id='method' name='method' label='Method' component={RailbillingMethodDropdown} onChange={handleMethodChange} />
              {!isNil(valueGetter('method')) && <Field id='methodDetails' name='methodDetails' label={getMethodDetailsLabel(valueGetter('method'))} component={FormInput} />}
              <SaveButton
                style={{ marginTop: '20px' }}
                onClick={(e) => {
                  e.preventDefault();
                  onSubmit({ closeOnSubmit: false, organizationId });
                }}
              />
            </FormElement>
          );
        }}

      />
    </Modal>
  );
};

export default OrganizationRailAndPortLocationsModal;
